import store from '@/store'
import dayjs from 'dayjs'
import { $amount } from '@/modules/Utils'

export class Ticket {
  static bankingTickets = []

  static formatLine (line) {
    // eslint-disable-next-line no-useless-escape
    return line.replace(!(/^[a-z0-9!"#$%&'()*+,.\/:;<=>?@\[\] ^_`{|}~-]*$/i), '')
  }

  static formatBankingTicket (ticket, merchant = false) {
    let res = { Marchand: merchant, Lignes: [] }

    let ticketFormatted = []

    // Contrôle html ticket
    if (ticket.indexOf('<br>') !== -1) {
      // Contrôle présence image
      let start = ticket.indexOf('<img')
      if (start !== -1) {
        // Extraction de l'image
        let end = ticket.indexOf('>', start)
        // Suppression de l'image du ticket
        ticket = ticket.substring(0, start) + ticket.substring(end + 1)
      }

      ticketFormatted = ticket.split('<br>')
    } else {
      ticketFormatted = ticket.split('\n')
    }

    ticketFormatted.forEach(line => {
      res.Lignes.push({
        Msg: this.formatLine(line),
        Taille: 2,
        Align: 'L'
      })
    })
    return res
  }
}

export function generateCustomerReceipt () {
  const lines = [
    { Msg: 'Vous venez de réaliser', Taille: 2, Align: 'C' },
    { Msg: 'une bonne action', Taille: 2, Align: 'C' },
    // { Msg: ' ', Taille: 2, Align: 'L' },
    { Msg: store.state.merchantName, Taille: 2, Align: 'C' }
  ]

  const pdvAddress = store.getters.posAddress
  if (pdvAddress !== null) {
    lines.push({ Msg: pdvAddress.AdresseA, Taille: 2, Align: 'C' })
    lines.push({ Msg: `${pdvAddress.CodePostal} ${pdvAddress.Ville}`, Taille: 2, Align: 'C' })

    if (pdvAddress.AdresseB !== null && pdvAddress.AdresseB !== '') {
      lines.push({ Msg: pdvAddress.AdresseB, Taille: 2, Align: 'C' })
    }

    if (pdvAddress.AdresseC !== null && pdvAddress.AdresseC !== '') {
      lines.push({ Msg: pdvAddress.AdresseC, Taille: 2, Align: 'C' })
    }
  }

  return { Lignes: [
      ...lines,
      ...getHeaderTicket(),
      ...getDetailTicket(),
      ...getFooterTicket()
  ] }
}

export function generateMerchantReceipt () {
  return { Lignes: [
    ...getHeaderTicket(),
    ...getDetailTicket(true),
    ...getFooterTicket(true)
  ] }
}

// ***********************************************************************************************
// ***********************************************************************************************

function getHeaderTicket () {
  const now = dayjs(Date.now())
  const ref = store.state.donationAmount > 0 ? store.state.donationRef : store.state.tipRef

  return [
    { Msg: now.format('DD/MM/YYYY'), Taille: 2, Align: 'L' },
    { Msg: now.format('HH:mm'), Taille: 2, Align: 'R' },
    // { Msg: ' ', Taille: 2, Align: 'L' },
    { Msg: 'No Transaction', Taille: 2, Align: 'L' },
    { Msg: ref, Taille: 2, Align: 'R' },
    // { Msg: ' ', Taille: 2, Align: 'L' }
  ]
}

function getDetailTicket (merchant = false) {
  let totalAmount = store.state.amount

  const lines = merchant ? [] : [
    { Msg: 'DETAILS TRANSACTION', Taille: 2, Align: 'L' },
    // { Msg: ' ', Taille: 2, Align: 'L' }
  ]

  lines.push({ Msg: `Montant achat ${merchant ? 'client' : ''}`, Taille: 2, Align: 'L' })
  lines.push({ Msg: $amount(totalAmount), Taille: 2, Align: 'R' })
  // lines.push({ Msg: ' ', Taille: 2, Align: 'L' })

  if (store.state.tipAmount > 0) {
    totalAmount += store.state.tipAmount

    lines.push({ Msg: `Montant pourboire ${merchant ? 'client' : ''}`, Taille: 2, Align: 'L' })
    lines.push({ Msg: $amount(store.state.tipAmount), Taille: 2, Align: 'R' })
    // lines.push({ Msg: ' ', Taille: 2, Align: 'L' })
  }

  if (store.state.donationAmount > 0) {
    totalAmount += store.state.donationAmount

    lines.push({ Msg: `Montant don ${merchant ? 'client' : ''}`, Taille: 2, Align: 'L' })
    lines.push({ Msg: $amount(store.state.donationAmount), Taille: 2, Align: 'R' })
    // lines.push({ Msg: ' ', Taille: 2, Align: 'L' })
    lines.push({ Msg: store.getters.donationCampaign.Associations[0].Enseigne, Taille: 2, Align: 'C' })
  }


  lines.push({ Msg: merchant ? 'Payé client' : 'Montant total', Taille: 2, Align: 'L' })
  lines.push({ Msg: $amount(totalAmount), Taille: 2, Align: 'R' })
  // lines.push({ Msg: ' ', Taille: 2, Align: 'L' })

  return lines
}

function getFooterTicket (merchant = false) {
  const lines = []
  if (merchant) {
    lines.push({ Msg: 'TICKET COMMERCE', Taille: 2, Align: 'L' })
  } else {
    lines.push({ Msg: 'Vous venez de réaliser une bonne action', Taille: 2, Align: 'C' })
  }
  lines.push({ Msg: 'Une solution de HEOH', Taille: 2, Align: 'C' })
  lines.push({ Msg: 'www.heoh.net', Taille: 2, Align: 'C' })

  // if (!merchant) {
  //   const qrCode = store.state.teleparameters.QrCodeAvis
  //   if (store.state.tipAmount > 0 && qrCode) {
  //     ticket += '<br />'
  //     ticket += '<p class="center">Donnez-nous votre avis !</p>'
  //     ticket += '<div class="center"><img src="data:image/png;base64, ' + qrCode + '" width="200" height="200" alt="qrcode"></div>'
  //     ticket += '<br />'
  //   }
  // }

  return lines
}
